import { lazy } from 'react';

import { ALLOWED_ROLES } from 'packages/utils';

import { PATHS } from './constants';

const CheckpointRoutesList = lazy(() => import('./screens/CheckpointRoutesList'));
const CheckpointRoute = lazy(() => import('./screens/CheckpointRoute'));
const ActiveCheckpointRoutesDashboard = lazy(
  () => import('./screens/ActiveCheckpointRoutesDashboard'),
);

const checkpointRoutesRoutes = [
  {
    component: ActiveCheckpointRoutesDashboard,
    path: PATHS.ACTIVE_CHECKPOINT_ROUTES,
    allowedRoles: ALLOWED_ROLES.ORGANIZATIONS.DIVISIONS.EXECUTIONS.LIST,
    onOrgChangeRedirectTo: `/:orgId/-/${PATHS.BASE_URL}`,
  },
  {
    component: CheckpointRoute,
    path: PATHS.EDIT_CHECKPOINT_ROUTE,
    allowedRoles: ALLOWED_ROLES.ORGANIZATIONS.DIVISIONS.SCHEDULES.UPDATE,
    onOrgChangeRedirectTo: `/:orgId/-/${PATHS.BASE_URL}`,
  },
  {
    component: CheckpointRoute,
    path: PATHS.CREATE_CHECKPOINT_ROUTE,
    writeOnly: true,
    allowedRoles: ALLOWED_ROLES.ORGANIZATIONS.DIVISIONS.SCHEDULES.CREATE,
    onOrgChangeRedirectTo: `/:orgId/-/${PATHS.BASE_URL}`,
  },
  {
    component: CheckpointRoutesList,
    path: PATHS.BASE_URL,
    allowedRoles: ALLOWED_ROLES.ORGANIZATIONS.DIVISIONS.SCHEDULES.LIST,
    onOrgChangeRedirectTo: `/:orgId/-/${PATHS.BASE_URL}`,
  },
];

export default checkpointRoutesRoutes;
